/* eslint-disable import/no-extraneous-dependencies */

import React from 'react';

import PropTypes from 'prop-types';

import { formFields as extFormFields } from '../../data/forms/partners';
import { ObjectPropType } from '../../utils/proptypes';
import SubmissionForm from './SubmissionForm';

const propTypes = {
  subjectTag: PropTypes.string.isRequired,
  formFields: ObjectPropType.isRequired,
  submissionMessage: PropTypes.string,
  submissionButtonText: PropTypes.string,
  referralSource: PropTypes.string,
  marketingOptIn: PropTypes.bool,
};

const defaultProps = {
  submissionMessage: '',
  submissionButtonText: '',
  referralSource: '',
  marketingOptIn: false,
};

export default function CustomerSignUpForm({
  subjectTag,
  formFields,
  submissionMessage,
  submissionButtonText,
  referralSource,
  marketingOptIn,
}) {
  const selectedFormFields = extFormFields[formFields || 'default'];

  const postSubmissionMessage =
    submissionMessage || 'Thanks! We’ll email you with a link to preview the website shortly.';

  const buttonMessage = submissionButtonText || 'Get A Website';

  return (
    <SubmissionForm
      style={{ minHeight: 492 }}
      fields={selectedFormFields}
      buttonMessage={buttonMessage}
      subjectTag={subjectTag}
      postSubmissionMessage={postSubmissionMessage}
      postSubmissionButtonMessage="Submit Another Response"
      referralSource={referralSource}
      marketingOptIn={marketingOptIn}
    />
  );
}

CustomerSignUpForm.propTypes = propTypes;
CustomerSignUpForm.defaultProps = defaultProps;
